/**
 * 組織区分の列挙型
 */
export const OrganizationKbnEnum = {
  /** 支社 */
  OFFICE: '1',
  /** 支店 */
  BRANCH: '2',
  /** 営業所 */
  SALES: '3',
};
